import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { taskManagementInterface, TaskManagementService } from '../task-management/service/task-management.service';
import { ClassificationService } from '../../classification/classification/service/classification.service';
import { TaskCustomFieldService } from './service/task-custom-field.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { classificationInterface } from 'src/app/util/interfaces/classification';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
	selector: 'register-form-task-custom-field',
	templateUrl: './task-custom-field.component.html',
	styleUrl: './task-custom-field.component.css',
})
export class TaskCustomFieldComponent implements OnInit {
	icons: any = {
		faTrash: faTrash,
	};

	labels: any = {
		lbl_tarefa_sem_dado_para_atualizar_campo_personalizado: 'No task available to update the custom field',
		lbl_tipo_servico_nao_definido: 'Service type not defined. Please select a valid classification',
		lbl_campo_personalizado_criado_sucesso: 'Custom field created successfully',
		lbl_erro_criar_campo_personalizado: 'Error creating custom field',
		lbl_campo_personalizado_atualizado_sucesso: 'Custom field updated successfully',
		lbl_erro_atualizar_campo_personalizado: 'Error updating custom field',
		lbl_campo_personalizado_deletado_sucesso: 'Custom field deleted successfully',
		lbl_erro_deletar_campo_personalizado: 'Error deleting custom field',
		lbl_campos_customizados_tarefas: 'Task Custom Fields',
		lbl_novo_campo_customizado_tarefa: 'New Task Custom Field',
	};

	classificationOptions = {
		isEditingClassification: true,
		alertField: [],
		selectedCustomer: this.ProfileService.userData().idCustomer,
		hideServiceType: [],
		hideField: ['impact', 'urgency', 'severity'],
		idCmdb: '',
		requiredField: [],
	};

	constructor(
		private labelsService: LabelsService,
		private notificationService: NotificationService,
		private taskManagementService: TaskManagementService,
		private classificationService: ClassificationService,
		private taskCustomFieldService: TaskCustomFieldService,
		private ProfileService: ProfileService
	) {}

	isLabelsLoading = true;
	isLoadingCustomfields = false;
	isUpdatingTaskCustomfield = false;
	isLoadingTasks = false;

	selectedTab = 'management';
	searchName = '';
	selectedIndex: number;

	taskCustomFieldData: genericFormI[] = [];
	taskCustomFieldDataSearch: genericFormI[] = [];
	taskCustomFieldArr: any[] = [];
	tasks: taskManagementInterface[] = [];

	searchClassification: classificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
	};

	selectedCustomfieldClassification: classificationInterface[] = [];
	selectedClassification: classificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
	};

	taskCustomFieldViewItems: mspTableHeaderI[] = [
		{
			name: 'name',
			value: 'lbl_geral_nome',
			colType: 'text',
		},
	];

	selectItems: genericFormI[] = [
		{
			name: 'selectItems',
			label: 'lbl_itens_da_selecao',
			inputType: 'multi-input',
			values: [],
			outItems: [],
			items: [
				{
					name: 'name',
					label: 'lbl_geral_nome',
					inputType: 'string',
					required: true,
					values: [''],
				},
			],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
			multiInputLineId: [],
			allowEdit: true,
			id: '',
		},
	];

	ngOnInit() {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLabelsLoading = false;
		});
	}

	clearInputs(isNew: boolean): void {
		this.taskCustomFieldData = isNew
			? [
					{
						inputType: '',
						analystView: false,
						required: 0,
						hidden: false,
						items: [],
						name: '',
						disabled: false,
						label: '',
						values: [],
						rawValues: [],
						id: '-1',
						multiInputLineId: [],
					},
				]
			: [];
	}

	setClassification(classification: string, classificationVariable: 'searchClassification' | 'selectedClassification'): void {
		const requestClassification: classificationInterface = JSON.parse(classification);

		this[classificationVariable][0] = {
			serviceType: requestClassification.serviceType || [],
			scope: requestClassification.scope || [],
			category: requestClassification.category || [],
			topic: requestClassification.topic || [],
			solutionArea: requestClassification.solutionArea || [],
		};

		if (classificationVariable == 'selectedClassification') {
			this.selectedCustomfieldClassification.length > 0
				? (this.selectedCustomfieldClassification[0] = this[classificationVariable][0])
				: this.selectedCustomfieldClassification.push(this[classificationVariable][0]);
			this.getGroupTasks();
		}
	}

	searchCustomfields(): void {
		// Verificar se searchClassification foi inicializado corretamente e se contém ao menos um elemento
		if (!this.searchClassification || !this.searchClassification[0] || !this.searchClassification[0].serviceType) {
			this.notificationService.setNotificationMessage(this.labels.lbl_para_buscar_por_classificacao_preencha_toda_classificacao);
			return;
		}

		// Garantir que a solução área foi preenchida
		if (this.searchClassification[0].serviceType.length > 0 && this.searchClassification[0].solutionArea.length === 0) {
			this.notificationService.setNotificationMessage(this.labels.lbl_para_buscar_por_classificacao_preencha_toda_classificacao);
			return;
		}

		// Evitar chamadas se já estiver carregando
		if (this.isLoadingCustomfields) return;

		this.selectedClassification = { ...this.searchClassification[0] };

		// Fazer a busca de campos customizados com o serviceType
		this.getTaskCustomFields(this.searchClassification[0]);
	}

	getTaskCustomFields(filters: classificationInterface): void {
		this.isLoadingCustomfields = true;

		this.taskCustomFieldService.getTaskCustomField({ serviceType: filters.serviceType[0].name }).subscribe({
			next: (taskCustomfield) => {
				this.taskCustomFieldArr = taskCustomfield;

				// Localizar dinamicamente o campo do tipo 'Select' em taskCustomFieldArr
				const selectField = this.taskCustomFieldArr.find((field) => field.inputType == 'select');

				if (selectField && selectField.items) {
					// Atribuir os itens do campo de seleção a this.selectItems[0].values
					this.selectItems[0].values = selectField.items;
				}

				this.selectedCustomfieldClassification.push(this.selectedClassification);
				this.getGroupTasks();
			},
			complete: () => {
				this.isLoadingCustomfields = false;
			},
		});
	}

	getGroupTasks(): void {
		this.tasks = [];
		this.isLoadingTasks = true;

		if (this.selectedCustomfieldClassification.length > 0) {
			const classification = this.selectedCustomfieldClassification[0];

			// Verifique se cada array tem pelo menos um elemento antes de acessar 'name'
			const hasSolutionArea =
				classification.solutionArea && classification.solutionArea.length > 0 && classification.solutionArea[0].name;
			const hasScope = classification.scope && classification.scope.length > 0 && classification.scope[0].name;
			const hasCategory = classification.category && classification.category.length > 0 && classification.category[0].name;
			const hasTopic = classification.topic && classification.topic.length > 0 && classification.topic[0].name;
			const hasServiceType =
				classification.serviceType && classification.serviceType.length > 0 && classification.serviceType[0].name;

			// Execute a lógica apenas se pelo menos um dos campos estiver presente
			if (hasSolutionArea && hasScope && hasCategory && hasTopic && hasServiceType) {
				this.taskManagementService
					.getGroupTasks({
						solutionArea: hasSolutionArea,
						scope: hasScope,
						category: hasCategory,
						topic: hasTopic,
						serviceType: hasServiceType,
					})
					.subscribe((data) => {
						this.tasks = data;
						this.isLoadingTasks = false;
					});
			} else {
				// Nenhuma tarefa a buscar, então apenas defina 'isLoadingTasks' como false
				this.isLoadingTasks = false;
			}
		} else {
			// Nenhuma classificação selecionada, então defina 'isLoadingTasks' como false
			this.isLoadingTasks = false;
		}
	}

	selectTaskCustomfield(taskCustomFieldData: genericFormI): void {
		this.isLoadingCustomfields = true;
		this.taskCustomFieldData = [taskCustomFieldData[0]];

		this.selectedTab = 'create';

		if (this.taskCustomFieldData) {
			this.isLoadingCustomfields = false;
		}
	}

	createTaskCustomField(): void {
		// Verificar se existem tarefas disponíveis
		if (this.tasks.length === 0) {
			this.notificationService.setNotificationMessage(this.labels.lbl_tarefa_sem_dado_para_atualizar_campo_personalizado);
			return;
		}

		// Verificar se já está atualizando
		if (this.isUpdatingTaskCustomfield) return;

		// Verificar se selectedClassification e serviceType estão corretamente definidos
		if (
			!this.selectedClassification[0] ||
			!this.selectedClassification[0].serviceType ||
			!this.selectedClassification[0].serviceType[0] ||
			!this.selectedClassification[0].serviceType[0].name
		) {
			this.notificationService.setNotificationMessage(this.labels.lbl_tipo_servico_nao_definido);
			return;
		}

		if (this.taskCustomFieldData[0].inputType == 'select') {
			this.taskCustomFieldData[0].items = this.selectItems[0].values;
		}

		this.isUpdatingTaskCustomfield = true;

		// Realizar a chamada da API
		this.taskCustomFieldService
			.postTaskCustomField({ serviceType: this.selectedClassification[0].serviceType[0].name }, this.taskCustomFieldData[0])
			.subscribe({
				next: (success) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_campo_personalizado_criado_sucesso);
				},
				error: (error) => {
					console.error(this.labels.lbl_erro_criar_campo_personalizado, error);
					this.notificationService.setNotificationMessage(this.labels.lbl_erro_criar_campo_personalizado);
				},
				complete: () => {
					this.isUpdatingTaskCustomfield = false;
				},
			});
	}

	updateTaskCustomField(): void {
		if (this.tasks.length === 0) {
			this.notificationService.setNotificationMessage(this.labels.lbl_tarefa_sem_dado_para_atualizar_campo_personalizado);
			return;
		}

		if (this.isUpdatingTaskCustomfield) return;

		this.isUpdatingTaskCustomfield = true;

		this.taskCustomFieldService
			.updateTaskCustomField({ serviceType: this.selectedClassification[0].serviceType[0].name }, this.taskCustomFieldData[0])
			.subscribe({
				next: (sucess) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_campo_personalizado_atualizado_sucesso);
				},
				error: (error) => {
					console.error(this.labels.lbl_erro_atualizar_campo_personalizado, error);
					this.notificationService.setNotificationMessage(this.labels.lbl_erro_atualizar_campo_personalizado);
				},
				complete: () => {
					this.isUpdatingTaskCustomfield = false;
				},
			});
	}

	deleteTaskCustomField(): void {
		this.taskCustomFieldService
			.deleteTaskCustomField({
				id: this.taskCustomFieldData[0].id,
				serviceType: this.selectedClassification[0].serviceType[0].name,
			})
			.subscribe({
				next: (sucess) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_campo_personalizado_deletado_sucesso);
				},
				error: (error) => {
					console.error(this.labels.lbl_erro_deletar_campo_personalizado, error);
					this.notificationService.setNotificationMessage(this.labels.lbl_erro_deletar_campo_personalizado);
				},
				complete: () => {
					this.selectedTab = 'management';
					this.clearInputs(false);
					this.isLoadingCustomfields = false;
				},
			});
	}

	confirmButton(elementReference: HTMLElement): void {
		this.notificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}
}
